module.exports = __webpack_public_path__ + "img/tour-banner.b2f7b420.svg";